// extracted by mini-css-extract-plugin
export default {"wrapper":"nav-item-module--wrapper--61e44","active":"nav-item-module--active--9edef","text":"nav-item-module--text--c71cf"};